import React, { useEffect, useRef, useState } from "react";
import { Alert, Backdrop, Box, Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, Grid, IconButton, MenuItem, Popover, Stack, TextField, Typography } from '@mui/material'

import './tablebypage.css'
import { LoadingButton, LocalizationProvider } from "@mui/lab";
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import { Api } from "../../../components/api";
import TreeViewTable from "./ByPageTable";
import { Form, FormikProvider, useFormik } from "formik";
import { fDateTo } from "../../../utils/formatTime";
import * as Yup from 'yup';
import axios from "axios";
import { format } from "date-fns";
import _ from "lodash";
import { useSnackbar } from "notistack";
import ByPageJsonToTable from "./ByPageJsonToTable";
import { CircleNotifications, Close, CloudDownload, Notifications } from "@mui/icons-material";
import LoadingPopover from "./LoadingPopover";




export default function ByPageLogToTable({ userId }) {

    const { enqueueSnackbar } = useSnackbar();
    const handleSnackbar = ({ variant, message }) => {
        enqueueSnackbar(message, { variant, autoHideDuration: 2000, anchorOrigin: { horizontal: 'right', vertical: 'bottom' } });
    };

    const [page, setPage] = useState(1);
    const [pageSize, setPageSize] = useState(50);
    const [maxPage, setMaxPage] = useState(null);

    const endRef = useRef(null);
    const [originalData, setOriginalData] = useState([]);
    const [devices, setDevices] = useState([])
    const [checked, setChecked] = useState([])
    const [checkedData, setCheckedData] = useState([]);
    const [loading, setLoading] = useState(false);


    const [rangStart, setRangStart] = useState(null);
    const [rangEnd, setRangEnd] = useState(null);
    const [rangMax, setRangMax] = useState(null);


    const [masterReport, setMasterReport] = useState([])
    const [type, setType] = useState({})
    const [dynamicValue, setDynamicValue] = useState({})



    const [openPopover, setOpenPopover] = useState(false);




    useEffect(() => {
        Api.get(`https://api.sitgps.com/Tracking/v3/gps_report?type=003`)
            .then((res) => {
                setMasterReport(res.data)

            })
            .catch(err => {
                const Message = err?.response?.data?.msg || "Unknown error";
                if (Message) {
                    handleSnackbar({ variant: "error", message: `${Message}` })
                }
            })
    }, [])



    const handleOpen = () => {
        setOpenPopover(true)
    };

    const handleClose = () => {
        setOpenPopover(false)
    };

    const [openPopoverAlert, setOpenPopoverAlert] = useState(false);

    const handleOpenAlert = () => {
        setOpenPopoverAlert(true)
    };

    const handleCloseAlert = () => {
        setOpenPopoverAlert(false)
    };




    useEffect(() => {
        Api.get(`/Tracking/DeviceByUsers?userid=${userId}`).then((res) => {
            var list = res.data.map(d => {
                return {
                    value: d.group_id,
                    label: d.group_name,
                    children: d.device.map(c => {
                        return {
                            value: c.id,
                            label: c.name,
                            value_og: c
                        }
                    })
                }
            });
            setDevices(list)
        }
        ).catch(err => {
            const Message = err?.response?.data?.msg || "Unknown error";
            if (Message) {
                handleSnackbar({ variant: "error", message: `${Message}` })
            }
        })
    }, [userId])


    const initialTime = new Date();
    const schema = Yup.object().shape({

    });
    const formik = useFormik({
        initialValues: {
            date_s: fDateTo(initialTime.setHours(0, 0, 0), 'yyyy-MM-dd HH:mm'),
            date_e: fDateTo(initialTime.setHours(23, 59, 59), 'yyyy-MM-dd HH:mm'),
        },
        validationSchema: schema,
        onSubmit: (values, { setSubmitting }) => {
            setMaxPage(null)
            setRangMax(null)
            const { date_s, date_e } = values
            const page_s = 1
            const reqC = {
                report: type?.id,
                dateStart: fDateTo(`${date_s}:00`, 'yyyy-MM-dd HH:mm:ss'),
                dateEnd: fDateTo(`${date_e}:59`, 'yyyy-MM-dd HH:mm:ss'),
                devices: checked,
                ...dynamicValue
            }

            Api.post(`https://historyv2.sitgps.com/Tracking/report_count`, reqC)
                .then((res) => {
                    const { data } = res
                    const totalPages = Math.ceil(data.msg / pageSize);
                    setMaxPage(totalPages)
                    setRangMax(data.msg === 0 ? null : data.msg)
                }).catch(err => {
                    const Message = err?.response?.data?.msg || "Unknown error";
                    if (Message) {
                        handleSnackbar({ variant: "error", message: `${Message}` })
                    }
                    setMaxPage(null)
                })
            onSubmitGetData({ setSubmitting: setSubmitting, page: page_s })
        }
    })

    const { errors, touched, values, isSubmitting, handleSubmit, getFieldProps, setFieldValue } = formik;


    const onSubmitGetData = ({ setSubmitting = () => { }, page }) => {

        if (checked.length <= 0) {
            handleSnackbar({ variant: "error", message: `กรุณาเลือกรถที่ต้องการดู` })
            setSubmitting()
            return
        }
        setLoading(true)
        const { date_s, date_e } = values
        const req = {
            report: type?.id,
            "page": page,
            "page_size": pageSize,
            "dateStart": fDateTo(`${date_s}:00`, 'yyyy-MM-dd HH:mm:ss'),
            "dateEnd": fDateTo(`${date_e}:59`, 'yyyy-MM-dd HH:mm:ss'),
            "devices": checked,
            ...dynamicValue
        }
        Api.post(`${type?.value?.api?.url}`, req)
            .then((res) => {
                const { data } = res
                if (setSubmitting) {
                    setSubmitting()
                }

                if (data.msg === "data null") {
                    handleSnackbar({ variant: "error", message: `No data!` })
                } else {
                    setPage(page)
                    setRangStart(data.msg.rang_start)
                    setRangEnd(data.msg.rang_end)
                    setOriginalData(data.msg.data)
                }
                setLoading(false)
            }).catch(err => {
                const Message = err?.response?.data?.msg || "Unknown error";
                if (Message) {
                    handleSnackbar({ variant: "error", message: `${Message}` })
                }
                if (setSubmitting) {
                    setSubmitting()
                }
                setRangStart(null)
                setRangEnd(null)
                setPage(1)
                setMaxPage(null)
                setOriginalData([])
                setLoading(false)
            })
    }

    const handleExportAlert = () => {
        handleCloseAlert()
        handleExport()
    }

    const handleExport = () => {
        setLoading(true)
        const { date_s, date_e } = values
        const req = {
            "username": userId,
            report: type?.id,
            "dateStart": fDateTo(`${date_s}:00`, 'yyyy-MM-dd HH:mm:ss'),
            "dateEnd": fDateTo(`${date_e}:59`, 'yyyy-MM-dd HH:mm:ss'),
            "devices": checked,
            ...dynamicValue
        }
        Api.post(`https://historyv2.sitgps.com/Tracking/report_by_page_export`, req)
            .then((res) => {
                handleSnackbar({ variant: "success", message: `กำลังสร้างไฟล์ กรุณากด ปุ่มดาวน์โหลด เมื่อสร้างสำเร็จ` })
                setLoading(false)
                handleOpen()
            }).catch(err => {
                const Message = err?.response?.data?.msg || "Unknown error";
                if (Message) {
                    handleSnackbar({ variant: "error", message: `${Message}` })
                }
                setLoading(false)
                setPage(1)
                setMaxPage(1)
            })
    }

    const onChangeChecked = (data) => {
        setChecked(data)
        setPage(1)
        setMaxPage(null)
        setOriginalData([])
        setRangStart(null)
        setRangEnd(null)
        setRangMax(null)
    }
    const onChangeCheckedData = (data) => {
        setCheckedData(data)
        setPage(1)
        setMaxPage(null)
        setOriginalData([])
        setRangStart(null)
        setRangEnd(null)
        setRangMax(null)
    }

    const onClear = () => {
        setPage(1)
        setMaxPage(null)
        setOriginalData([])
        setRangStart(null)
        setRangEnd(null)
        setRangMax(null)
    }


    return (
        <div>
            <Backdrop
                sx={(theme) => ({ color: '#fff', zIndex: theme.zIndex.drawer + 1 })}
                open={loading}
            >
                <CircularProgress color="inherit" />
            </Backdrop>
            <LocalizationProvider dateAdapter={AdapterDateFns}>
                <Stack direction="row" spacing={1}>
                    <Box sx={{ minWidth: "20%", maxWidth: "20%", minHeight: "calc(100vh)", maxHeight: "calc(100vh)", overflow: "auto" }}>
                        <Box sx={{ padding: "10px" }}>
                            <TreeViewTable
                                nodes={devices}
                                checked={checked}
                                setChecked={onChangeChecked}
                                checkedData={checkedData}
                                setCheckedData={onChangeCheckedData}
                                maxHeight={"calc(100vh - 118px)"}
                                height={"calc(100vh - 118px)"}
                                multi={true}
                            // multi={!type?.value?.device_only}
                            />
                        </Box>
                    </Box>
                    <Box
                        sx={{
                            width: "80%",
                            height: "100vh",
                            display: "flex",
                            flexDirection: "column",
                            overflow: "hidden",
                        }}
                    >
                        <Box sx={{ p: 1, flexShrink: 0 }}>
                            <FormikProvider value={formik}>
                                <Form autoComplete="off" noValidate onSubmit={handleSubmit}>
                                    <Grid container spacing={1}>
                                        <Grid item md={3}>
                                            <TextField
                                                label="ประเภทรายงาน"
                                                fullWidth
                                                autoComplete="off"
                                                name="iframe"
                                                size="small"
                                                select
                                                value={type.id}
                                                onChange={(e) => {
                                                    onClear()
                                                    const selected = masterReport.find((r) => r.id === e.target.value);
                                                    setType(selected);
                                                    setDynamicValue({})
                                                    if (selected?.dynamic_value?.length > 0) {
                                                        const result = selected?.dynamic_value?.reduce((acc, item) => {
                                                            acc[item.id] = item.value;
                                                            return acc;
                                                        }, {});
                                                        setDynamicValue(result)
                                                    }
                                                    // if (selected?.value?.device_only && checked.length > 1) {
                                                    //     setChecked([])
                                                    // }
                                                }}
                                            >
                                                {masterReport.map((iframe) => (
                                                    <MenuItem key={iframe.id} value={iframe.id}>
                                                        {iframe.name}
                                                    </MenuItem>
                                                ))}
                                            </TextField>
                                        </Grid>
                                        <Grid item md={3}>
                                            <TextField
                                                // disabled={typeof type === "object" && !Array.isArray(type) && Object.keys(type).length === 0}
                                                value={values.date_s}
                                                onChange={(val) => {
                                                    onClear()
                                                    const { value } = val.target
                                                    setFieldValue('date_s', `${fDateTo(value, "yyyy-MM-dd HH:mm")}`);
                                                    setFieldValue('date_e', `${fDateTo(new Date(value).setHours(23, 59, 59), "yyyy-MM-dd HH:mm")}`);
                                                    // endRef.current.focus();
                                                    // endRef.current.click();
                                                }}
                                                type="datetime-local"
                                                size="small"
                                                fullWidth
                                                placeholder="YYYY/MM/DD"
                                                autoComplete="off"
                                                error={Boolean(touched.date_s && errors.date_s)}
                                                helperText={touched.date_s && errors.date_s}
                                                label="วันเวลาเริ่ม"
                                                inputProps={{
                                                    // readOnly: true,
                                                    ampm: false,
                                                    max: fDateTo(new Date().setHours(23, 59, 59), "yyyy-MM-dd HH:mm"),
                                                }}
                                            />
                                        </Grid>
                                        <Grid item md={3}>
                                            <TextField
                                                inputRef={endRef}
                                                // disabled={typeof type === "object" && !Array.isArray(type) && Object.keys(type).length === 0}
                                                value={values.date_e}
                                                onChange={(val) => {
                                                    onClear()
                                                    const { value } = val.target
                                                    setFieldValue('date_e', `${fDateTo(value, "yyyy-MM-dd HH:mm")}`);
                                                }}
                                                type="datetime-local"
                                                size="small"
                                                fullWidth
                                                placeholder="YYYY/MM/DD"
                                                autoComplete="off"
                                                error={Boolean(touched.date_e && errors.date_e)}
                                                helperText={touched.date_e && errors.date_e}
                                                label="ถึงวันเวลา"
                                                readOnly={true}
                                                inputProps={{
                                                    // readOnly: true,
                                                    ampm: false,
                                                    min: fDateTo(new Date(values.date_s), "yyyy-MM-dd HH:mm"),
                                                    max: fDateTo(new Date().setHours(23, 59, 59), "yyyy-MM-dd HH:mm"),
                                                }}
                                            />
                                        </Grid>
                                        <Grid item md={3}>
                                            <Stack direction="row" spacing={1} justifyContent="space-around">
                                                <LoadingButton
                                                    disabled={typeof type === "object" && !Array.isArray(type) && Object.keys(type).length === 0}
                                                    variant="contained"
                                                    type="submit"
                                                    loading={isSubmitting}
                                                >
                                                    ค้นหา
                                                </LoadingButton>

                                                <IconButton onClick={handleOpenAlert} disabled={originalData.length <= 0} color="secondary" aria-label="CloudDownload">
                                                    <CloudDownload />
                                                </IconButton>

                                                <IconButton onClick={handleOpen} aria-label="CircleNotifications">
                                                    <CircleNotifications />
                                                </IconButton>

                                                <LoadingPopover
                                                    open={openPopover}
                                                    onClose={handleClose}
                                                    userId={userId}
                                                />

                                                {/* <Button variant="outlined" disabled={originalData.length <= 0} onClick={handleExport}>Export CSV</Button> */}
                                            </Stack>
                                        </Grid>
                                        {Array.isArray(type?.value?.dynamic_value) &&
                                            type?.value.dynamic_value.map((item, index) => (
                                                <Grid item md={3} key={index}>
                                                    <TextField
                                                        fullWidth
                                                        size="small"
                                                        label={item.detail}
                                                        type={item.type === "int" ? "number" : "text"}
                                                        value={dynamicValue[item.id] ?? ""}
                                                        onChange={(e) => {
                                                            const v = e.target.value;
                                                            setDynamicValue((prev) => ({
                                                                ...prev,
                                                                [item.id]: item.type === "int"
                                                                    ? v === "" ? "" : Number(v)
                                                                    : v,
                                                            }));
                                                        }}
                                                    />
                                                </Grid>
                                            ))}
                                    </Grid>
                                </Form>
                            </FormikProvider>
                        </Box>
                        <Box
                            sx={{
                                flex: 1,
                                overflow: "auto",
                                px: 1,
                            }}
                        >
                            <ByPageJsonToTable data={originalData} />
                        </Box>
                        <Box sx={{ p: 1, flexShrink: 0 }}>
                            <Stack direction={1} justifyContent="space-between">
                                <Box>
                                    <Button
                                        variant="contained"
                                        disabled={page === 1}
                                        onClick={() => {
                                            onSubmitGetData({ page: page - 1 })
                                        }}
                                        size="small">
                                        Prev
                                    </Button>
                                    {/* <span style={{ margin: "0 10px", userSelect: "none" }}>{maxPage > 0 ? `หน้า ${page} / ${maxPage}` : `หน้า 0 / 0`} </span> */}
                                    {/* <span style={{ margin: "0 10px", userSelect: "none" }}>{maxPage === null ? `หน้า ${page} / ${`NA`}` : `หน้า ${page} / ${maxPage}`} </span> */}
                                    <span style={{ margin: "0 10px", userSelect: "none" }}>{rangStart === null ? `${`NA`}` : `${rangStart} - `} {rangEnd === null ? `${`NA`}` : `${rangEnd}`} {rangMax === null ? `${` / NA`}` : ` / ${rangMax.toLocaleString("en-US")}`}</span>
                                    <Button
                                        variant="contained"
                                        // disabled={isNaN(maxPage) ? true : page === maxPage}
                                        disabled={typeof type === "object" && !Array.isArray(type) && Object.keys(type).length === 0 || page === maxPage || originalData.length === 0}
                                        onClick={() => {
                                            onSubmitGetData({ page: page + 1 })
                                        }}
                                        size="small"
                                    >
                                        Next
                                    </Button>
                                </Box>
                                <Box>
                                    <select
                                        size="small"
                                        value={pageSize}
                                        onChange={(e) => {
                                            setPageSize(Number(e.target.value));
                                            setPage(1);
                                            setOriginalData([])
                                            setMaxPage(null)
                                        }}
                                    >
                                        <option key={`setPageSize-1`} value={10}>
                                            {10}
                                        </option>
                                        <option key={`setPageSize-2`} value={20}>
                                            {20}
                                        </option>
                                        <option key={`setPageSize-3`} value={30}>
                                            {30}
                                        </option>
                                        <option key={`setPageSize-4`} value={40}>
                                            {40}
                                        </option>
                                        <option key={`setPageSize-5`} value={50}>
                                            {50}
                                        </option>
                                    </select>
                                </Box>
                            </Stack>
                        </Box>
                    </Box>
                </Stack>
            </LocalizationProvider>

            <Dialog onClose={handleCloseAlert} open={openPopoverAlert} fullWidth maxWidth="sm">
                <DialogTitle>
                    แจ้งเตือน
                    <IconButton
                        aria-label="close"
                        onClick={handleCloseAlert}
                        sx={{ position: 'absolute', right: 8, top: 8 }}
                    >
                        <Close />
                    </IconButton>
                </DialogTitle>
                <DialogContent>
                    <Alert color="warning">
                        ต้องการเริ่มสร้างไฟล์ส่งออกหรือไม่?
                        <br />
                        การสร้างไฟล์อาจใช้เวลาสักครู่ กรุณากดเพียงครั้งเดียว
                    </Alert>
                </DialogContent>
                <DialogActions>
                    <Button variant="contained" size="small" color="primary" onClick={handleExportAlert}>ยืนยัน</Button>
                    <Button variant="contained" size="small" color="secondary" onClick={handleCloseAlert}>ยกเลิก</Button>
                </DialogActions>
            </Dialog>
        </div >
    );
}